/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var FILTER_VALUE_UNSELECTED = '0_no_filter';

	var SearchResultFilter = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance (for counting results in filters)
		searchProcessors: null,
		// Available fitlers
		filters: null,

		on: function(callback) {
			callback();
		},

		after: function() {},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;

			this.findElements();
			this.attachListeners();

			// Don’t trigger a search, just set the initial filter
			searchContainer.filter = this.currentFilter();
		},

		searchConfigUpdated: function(searchConfig) {
			var mod = this;

			mod.$filterContainer.addClass('active');
			mod.$title.removeClass('hidden');

			// jshint forin: false
			var filter = searchConfig.filter || {};
			for(var filterName in mod.filters) {
				var filterConfig = mod.filters[filterName];
				var filterValueConfig = null;

				// Search the selected filter. If not found, assume no filter was to be used.
				if(filterName in filter && filter[filterName] in filterConfig) {
					filterValueConfig = filterConfig[filter[filterName]];
				} else {
					filterValueConfig = filterConfig[FILTER_VALUE_UNSELECTED] || filterConfig[''];
				}
				if(filterValueConfig) {
					// Update the filter DOM
					mod.activateFilter(null, filterValueConfig);
				}

				// Trigger queries for the result counts
				var filterExceptCurrent = SCS.search.util.extend({}, filter);
				if(filterName in filterExceptCurrent) {
					delete filterExceptCurrent[filterName];
				}
				var configForSubquery = SCS.search.util.extend({}, searchConfig, {filter: filterExceptCurrent});
				mod.searchProcessors[filterName].process(configForSubquery);
			}
		},

		findElements: function() {
			var mod = this;

			mod.$filterContainer = mod.$ctx.find('.scs-sitesearch-searchfilter');
			mod.$title = mod.$ctx.find('.scs-sitesearchfilter-title');

			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = mod.searchContainer.$config;
			}

			var filters = mod.filters = {};
			var searchProcessors = mod.searchProcessors = {};

			var $filters = mod.$filterContainer.find('.scs-sitesearch-filter-menu');
			$filters.each(function() {
				var $filter = $(this);

				var filter = $filter.attr('data-gsa-filter');

				var filterConfig = filters[filter] = {};
				var $filterValues = $filter.find('.scs-sitesearch-filter-menu-item');

				// Initialize the search processor that count how many times the current search term appears in the filter values
				searchProcessors[filter] = mod.initSearchProcessor($config, filter);

				$filterValues.each(function() {
					var $filterValue = $(this);
					var filterValue = $filterValue.attr('data-gsa-filter-value');
					if(!filterValue || filterValue === FILTER_VALUE_UNSELECTED) {
						// Always show the “Show All” filter
						$filterValue.addClass('is-reset-button');
					}
					filterConfig[filterValue] = {
						$filter: $filter,
						$filterValue: $filterValue,
						$otherFilterValues: $filterValues.not($filterValue),
						filter: filter,
						filterValue: filterValue
					};
				});
			});

			// Add mobile-only toggle element
			var $toggler = mod.$ctx.find('.scs-sitesearch-searchfilter-mobile-button');
			if($toggler.length) {
				$toggler.click(function() {
					mod.$filterContainer.toggle();
					$toggler.toggleClass('active');
				});
				mod.$filterContainer.hide();
			}
		},

		// Initialize processors that count the unfiltered queries for us
		initSearchProcessor: function($config, filter) {
			var mod = this;

			var defaults = {
				requester: 'logic'
			};
			// Use the same config as for the search itself so the queries can be consolidated by deduplicatedBackend
			var resultLimit = parseInt($config.attr('data-sitesearch-shownResults'), 10);
			if(!isNaN(resultLimit)) {
				defaults.resultLimit = resultLimit;
			}
			var processor = SCS.search.orchestration.forSerp(
				$config.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de',
				defaults
			);
			processor.responder(SCS.search.util.respondTo({
				data: $.proxy(mod.updateFilterCounts, mod, filter)
			}, mod));

			return processor;
		},

		updateFilterCounts: function(filter, processor, data, config) {
			var facets = config.facets || {};

			var facet = (facets[filter] || {}).values || {};
			var filterConfig = this.filters[filter];
			for(var filterValue in filterConfig) {
				// jshint forin: false
				var filterValueConfig = filterConfig[filterValue];
				if(filterValue in facet) {
					filterValueConfig.$filterValue.attr('data-result-count', facet[filterValue].count);
				} else {
					filterValueConfig.$filterValue.attr('data-result-count', 0);
				}
			}
		},

		attachListeners: function() {
			var mod = this;

			// jshint forin: false
			for(var filter in mod.filters) {
				var filterConfig = mod.filters[filter];
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					filterValueConfig.$filterValue.click(filterValueConfig, $.proxy(mod.activateFilter, mod));
				}
			}
		},

		activateFilter: function(event, filterValueConfig) {
			filterValueConfig = filterValueConfig || event.data;
			var $filterValue = filterValueConfig.$filterValue;
			if($filterValue.is('.active')) {
				// Filter already active, do nothing
				return;
			}
			if(event) {
				event.preventDefault();
			}

			filterValueConfig.$otherFilterValues.removeClass('active');
			filterValueConfig.$filterValue.addClass('active');

			if(event) {
				var previousFilter = this.searchContainer.currentConfig().filter;

				// Change came from a click event, not to just update filter display
				this.searchContainer.filter = this.currentFilter();
				this.searchContainer.configChanged(true);

				Module.SearchResultContainer.trackClick(
					'dynnav.'+filterValueConfig.filter+'.'+filterValueConfig.filterValue,
					this.searchContainer.currentConfig(),
					{
						previousFilter: previousFilter,
						filterName: filterValueConfig.filter,
						filterValue: filterValueConfig.filter,
						url: document.location.href
					},
					this.searchProcessors[filterValueConfig.filter]
				);
			}
		},

		// Calculates the current filter (as applicatble for Tc.Module.SearchResultContainer) from the current DOM state
		currentFilter: function() {
			var mod = this;

			var currentFilter = {};

			// jshint forin: false
			for(var filter in mod.filters) {
				var filterConfig = mod.filters[filter];
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					if(!filterValueConfig.$filterValue.is('.active')) {
						// Find next 
						continue;
					}
					if(filterValueConfig.filterValue && filterValueConfig.filterValue !== FILTER_VALUE_UNSELECTED) {
						// This sets the filter properties
						currentFilter[filter] = filterValueConfig.filterValue;
					}
					break;
				}
			}

			return currentFilter;
		},

		getFilterTitles: function() {
			var result = {};

			// jshint forin: false
			for(var filter in this.filters) {
				var filterConfig = this.filters[filter];
				result[filter] = {};
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					result[filter][filterValue] = $.trim(filterValueConfig.$filterValue.text());
				}
			}

			return result;
		}

	});

	Module.SearchResultFilter = SearchResultFilter;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultFilter.js
// module id = 318
// module chunks = 0